import React from "react";
import { Button, Typography } from "@mui/material";
class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleClick = () => {
    window.localStorage.clear();
    window.location.reload();
  }

  render() {

    const errorContainerStyle = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      fontFamily: "Arial, sans-serif"
    };

    const errorContentStyle = {
      textAlign: "center"
    };

    const errorCodeStyle = {
      fontSize: "180px",
      color: "#fff",
      marginBottom: "20px"
    };

    const errorTextStyle = {
      fontSize: "24px",
      color: '#f68f3f',
      marginBottom: "20px"
    };




    if (this.state.errorInfo) {
      return (
        <div style={errorContainerStyle}>
          <div style={errorContentStyle}>
            <div style={errorCodeStyle}><Typography fontSize={'140px'} >Oops!</Typography></div>
            <div style={errorTextStyle}><Typography>Something went wrong.</Typography></div>
            <Button onClick={this.handleClick} color='primary' variant='contained' >
              <Typography >Clear storage and refresh</Typography>
            </Button>
          </div>
        </div>
      );
    } else {
      return this.props.children;
    }
  }
}

export default RootErrorBoundary;